/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$inboundSchema,
} from "./agentpolicyselector.js";

export const AgentPolicyGrantEffect = {
  Allow: "allow",
} as const;
export type AgentPolicyGrantEffect = ClosedEnum<typeof AgentPolicyGrantEffect>;

export type AgentPolicyGrant = {
  createdAt: Date;
  effect: AgentPolicyGrantEffect;
  id: string;
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
  updatedAt: Date;
};

/** @internal */
export const AgentPolicyGrantEffect$inboundSchema: z.ZodMiniEnum<
  typeof AgentPolicyGrantEffect
> = z.enum(AgentPolicyGrantEffect);

/** @internal */
export const AgentPolicyGrant$inboundSchema: z.ZodMiniType<
  AgentPolicyGrant,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    effect: AgentPolicyGrantEffect$inboundSchema,
    id: z.string(),
    scope: z.string(),
    selector: AgentPolicySelector$inboundSchema,
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "updated_at": "updatedAt",
    });
  }),
);

export function agentPolicyGrantFromJSON(
  jsonString: string,
): SafeParseResult<AgentPolicyGrant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPolicyGrant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPolicyGrant' from JSON`,
  );
}
